import type { StyleValue } from "@circle-react-shared/BuilderUI/StyleValue.types";

export const getPaddingOptions = ({
  defaultValue = {
    paddingTop: "10",
    paddingBottom: "10",
    paddingLeft: "10",
    paddingRight: "10",
  },
}: {
  defaultValue?: {
    paddingTop: string;
    paddingBottom: string;
    paddingLeft: string;
    paddingRight: string;
  };
}): StyleValue => ({
  type: "box-model",
  value: defaultValue,
});

export const getMarginOptions = ({
  defaultValue = {
    marginTop: "10",
    marginBottom: "10",
    marginLeft: "10",
    marginRight: "10",
  },
}: {
  defaultValue?: {
    marginTop: string;
    marginBottom: string;
    marginLeft: string;
    marginRight: string;
  };
}): StyleValue => ({
  type: "box-model",
  value: defaultValue,
});
